export default __webpack_public_path__ + "static/media/bg-plane.89ae7945.png";